import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';
import _size from 'lodash/size';
import _castArray from 'lodash/castArray';
import _isNil from 'lodash/isNil';

// Components
import { EMPTY_ARRAY, EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import ActionsList from '../../../molecules/actionsList';

// Constants
import TABLE_ACTION_TYPES from '../../../molecules/tableInputField/constants/TableInputField.actionTypes';

// Builders
import ColumnConfig from '../builders/ColumnConfig';
var NO_VISIBLE_ACTION_COUNT = 0;
var VISIBLE_ACTION_COUNT = 1;
var DEFAULT_COLUMN_CONFIG = new ColumnConfig();
var ActionCellRenderer = /*#__PURE__*/function (_Component) {
  _inherits(ActionCellRenderer, _Component);
  var _super = _createSuper(ActionCellRenderer);
  function ActionCellRenderer() {
    var _this;
    _classCallCheck(this, ActionCellRenderer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleActionClick", function (actionType) {
      var _this$props = _this.props,
        rowIndex = _this$props.rowIndex,
        rowData = _this$props.rowData,
        onAction = _this$props.onAction,
        columnConfig = _this$props.columnConfig;
      onAction({
        type: TABLE_ACTION_TYPES.TABLE_ACTION_CLICK,
        payload: {
          actionType: actionType,
          nestingPath: _castArray(rowIndex),
          id: columnConfig.getColumnId(),
          rowData: rowData
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getVisibleActionCount", function () {
      var actions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_ARRAY;
      var actionsLength = _size(actions);
      if (actionsLength > 1) {
        return NO_VISIBLE_ACTION_COUNT;
      }
      if (actionsLength === 1) {
        return VISIBLE_ACTION_COUNT;
      }
      return undefined;
    });
    return _this;
  }
  _createClass(ActionCellRenderer, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        actions = _this$props2.actions,
        visibleActionCount = _this$props2.visibleActionCount,
        visibleActionsClassName = _this$props2.visibleActionsClassName,
        actionListClassName = _this$props2.actionListClassName;
      var visibleActionsCount = _isNil(visibleActionCount) ? this.getVisibleActionCount(actions) : visibleActionCount;
      return /*#__PURE__*/React.createElement(ActionsList, {
        actions: actions,
        visibleActionCount: visibleActionsCount,
        visibleActionsClassName: visibleActionsClassName,
        onActionClick: this.handleActionClick,
        className: actionListClassName
      });
    }
  }]);
  return ActionCellRenderer;
}(Component);
ActionCellRenderer.propTypes = {
  onAction: PropTypes.func,
  actions: PropTypes.array,
  rowIndex: PropTypes.number,
  columnConfig: PropTypes.instanceOf(ColumnConfig),
  visibleActionCount: PropTypes.number,
  rowData: PropTypes.object,
  visibleActionsClassName: PropTypes.string,
  actionListClassName: PropTypes.string
};
ActionCellRenderer.defaultProps = {
  onAction: _noop,
  actions: EMPTY_ARRAY,
  rowIndex: 0,
  columnConfig: DEFAULT_COLUMN_CONFIG,
  visibleActionCount: undefined,
  rowData: EMPTY_OBJECT,
  visibleActionsClassName: undefined,
  actionListClassName: undefined
};
export default ActionCellRenderer;